<script setup lang="ts">
import type { ISizes } from './styles';
import { isSlotEmpty } from '~/types/Slot';

interface Props {
  size?: ISizes | null | undefined;
  showDefaultClose?: boolean | undefined;
  bgClickClose?: boolean | undefined;
  bgColor?: String | string | undefined;
  value?: boolean | null | undefined;
  rounded?: boolean | undefined;
  className?: String | string | undefined;
  [x: string]: any;
};

const props = withDefaults(defineProps<Props>(), {
  showDefaultClose: false,
  bgClickClose: false,
  bgColor: 'bg-slate-600 transition-opacity opacity-75',
  rounded: true,
});

const slots = useSlots();

const emit = defineEmits(['click', 'change']);
const model = defineModel<boolean>({ required: false, default: false });

const init = (): void => {
  if (props.value !== undefined)
    model.value = props.value;
};
onMounted(init);

// Expose usefull functions
defineExpose({ init });
</script>

<template>
  <teleport to="#__nuxt>div">
    <transition name="fade">
      <div
        v-if="model"
        class="fixed inset-0 w-full h-full"
        @click="(e: Event) => emit('click', e)">
        <slot name="background">
          <span
            :class="[
              'fixed inset-0',
              bgColor,
              (((isSlotEmpty(slots?.default) && (! slots?.body) && (! slots?.box)) || bgClickClose) && 'cursor-pointer')
            ]"
            @click="(e: Event) => (((isSlotEmpty(slots?.default)  && (! slots?.body) && (! slots?.box)) || bgClickClose) ? (model = false, emit('change', e)) : null)" />
        </slot>
        <div
          :class="[
            'fixed inset-0',
            (((isSlotEmpty(slots?.default) && (! slots?.body) && (! slots?.box)) || bgClickClose) && 'pointer-events-none')
          ]">
          <slot name="body">
            <div class="w-full h-full flex justify-center items-center">
              <slot name="box">
                <BaseBox
                  :size="size"
                  :rounded="rounded"
                  :class="[
                    'transform transition-all max-w-screen max-h-screen',
                    (((isSlotEmpty(slots?.default) && (! slots?.body) && (! slots?.box)) || bgClickClose) && 'pointer-events-auto'),
                    className
                  ]">
                  <slot>
                    <h3 class="bg-white rounded-lg shadow-xl p-6 text-center text-lg font-bold text-red-500">
                      ! NO CONTENT !
                    </h3>
                  </slot>
                </BaseBox>
              </slot>
            </div>
          </slot>
        </div>
        <slot name="close">
          <div
            v-if="showDefaultClose"
            class="fixed top-0 right-0 p-2 sm:p-3 lg:p-4 xl:p-5 text-black">
            <button
              type="button"
              class="flex justify-center items-center scale-[1.0] sm:scale-[1.1] lg:scale-[1.2] xl:scale-[1.3] hover:scale-[1.1] sm:hover:scale-[1.25] lg:hover:scale-[1.35] xl:hover:scale-[1.5] ease-in duration-200"
              @click="(e: Event) => (model = false, emit('change', e))">
              <Icon
                name="bx:x"
                size="48" />
            </button>
          </div>
        </slot>
      </div>
    </transition>
  </teleport>
</template>


<style lang="scss" scoped>
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transition: ease 0.2s;
}

.fade-leave-from,
.fade-enter-to {
  opacity: 1;
  transition: ease 0.2s;
}
</style>
